import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { trackEvent } from '../../../components/Analytics/TrackedClick';
import Img from '../../../components/Img';
import { getClickAttrs } from '../../../components/Analytics/gtag';

import styles from './powerPerksPage.scss';

const FooterBanner = ({ auth, subscriptionPlans, isLoadingPlans, shouldShowPricing, onPowerClick }) => {
    const hasPastDueSubscription = auth?.user?.hasPastDueSubscription;

    // Get annual plan and pricing text directly
    const annualPlan = subscriptionPlans.find(plan => plan.interval === 'year');
    const pricingText = annualPlan?.displayMonthlyAmount
        ? `Pricing at ${annualPlan.displayMonthlyAmount}/mo.`
        : 'Pricing at $10/mo.';

    const handlePowerClick = () => {
        // segment call - mapped to GA4
        trackEvent(`Power Perks Power Lp Start Button Bottom Click Segment`, {
            page: 'Home',
            button: 'Start Power Now',
            action: 'click',
        });
        onPowerClick();
    };

    return (
        <div className={styles.footerBanner} data-testid="power-perks.footer-banner">
            <div className="container">
                <div className="row">
                    <div className="col-12 d-block d-md-none">
                        <div className={styles.bg}>
                            <Img src="/img/v3/graphics/perks/mobile/banner-footer-power-up.png" />
                        </div>
                        <div className={styles.wrapper}>
                            <div className={styles.text}>
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-10 offset-1 text-center">
                                            <div className={`mb8`}>
                                                <p className={styles.bannerFonts} data-testid="power-perks.footer-banner.mobile.text">
                                                Power up your playing experience with access to exclusive benefits, perks, and more!
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-10 offset-1 text-center">
                                            {hasPastDueSubscription ? (
                                                <Link
                                                    className="btn btn-lg btn-primary text-uppercase"
                                                    to="/subscriptions"
                                                    data-testid="power-perks.footer-banner.mobile.resume-power-link"
                                                    {...getClickAttrs({
                                                        category: 'Resume Power',
                                                        context: `Power Perks Power Lp Resume Power Button Bottom Click`,
                                                        location: 'Power Perks Page - Footer Banner',
                                                    })}
                                                >
                                                    Resume Power
                                                </Link>
                                            ) : (
                                                <div
                                                    className="btn btn-lg btn-primary text-uppercase"
                                                    onClick={handlePowerClick}
                                                    data-testid="power-perks.footer-banner.mobile.start-power-btn"
                                                    {...getClickAttrs({
                                                        category: 'Power Upgrade',
                                                        context: `Power Perks Power Lp Start Power Now Button Bottom Click`,
                                                        location: 'Power Perks Page - Footer Banner',
                                                    })}
                                                >
                                                    Start Power Now
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 d-none d-md-block">
                        <div className={styles.wrapper}>
                            <div className={styles.bg}>
                                <Img src="/img/v3/graphics/perks/banner-footer-power-up.png" />
                            </div>
                            <div className={styles.text}>
                                <div className="col-md-6 offset-md-6">
                                    <div className="col-md-10 offset-md-1 text-center p0">
                                        <div className={`mb8`}>
                                            <p className={styles.bannerFonts} data-testid="power-perks.footer-banner.desktop.text">
                                            Power up your playing experience with access to exclusive benefits, perks, and more!
                                            </p>
                                        </div>
                                        {hasPastDueSubscription ? (
                                            <Link
                                                className={`${styles.buttonMargin} btn btn-lg btn-primary text-uppercase buttonMargin`}
                                                to="/subscriptions"
                                                data-testid="power-perks.footer-banner.desktop.resume-power-link"
                                                {...getClickAttrs({
                                                    category: 'Resume Power',
                                                    context: `Power Perks Power Lp Resume Power Button Bottom Click`,
                                                    location: 'Power Perks Page - Footer Banner',
                                                })}
                                            >
                                                Resume Power
                                            </Link>
                                        ) : (
                                            <div
                                                className={`${styles.buttonMargin} btn btn-lg btn-primary text-uppercase buttonMargin`}
                                                onClick={handlePowerClick}
                                                data-testid="power-perks.footer-banner.desktop.start-power-btn"
                                                {...getClickAttrs({
                                                    category: 'Power Upgrade',
                                                    context: `Power Perks Power Lp Start Power Now Button Bottom Click`,
                                                    location: 'Power Perks Page - Footer Banner',
                                                })}
                                            >
                                                Start Power Now
                                            </div>
                                        )}
                                    </div>
                                    {shouldShowPricing && !isLoadingPlans && auth?.user && !hasPastDueSubscription && (
                                        <div className="col-md-10 offset-md-1 text-center p0 mt4">
                                            <small className="fs12" data-testid="power-perks.footer-banner.desktop.pricing-text">{pricingText} Cancel anytime</small>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

FooterBanner.propTypes = {
    auth: PropTypes.shape({
        user: PropTypes.shape({
            isPowered: PropTypes.bool,
        }),
    }).isRequired,
    subscriptionPlans: PropTypes.arrayOf(PropTypes.object).isRequired,
    isLoadingPlans: PropTypes.bool.isRequired,
    shouldShowPricing: PropTypes.bool.isRequired,
    onPowerClick: PropTypes.func.isRequired,
};

export default FooterBanner;
